/* eslint-disable @next/next/no-img-element */
import { useEffect, useState } from 'react'
import MobileNav from 'components/Layout/MobileNav'
import DesktopNav from 'components/Layout/DesktopNav'
import Header from './Header'
import MenuButton from './MenuButton'
import TosBanner from './TosBanner'
import useAlgoUsd from 'hooks/useAlgoUsd'

// Countdown imports start
import { useLaunchTimer, LaunchTimer } from 'components/LaunchTimer'
import Confetti from 'components/name/Confetti'
import usePrevious from 'hooks/usePrevious'
// Countdown imports end

type LayoutProps = {
  children: React.ReactNode
  pathname: string
}

export default function Layout({ children, pathname }: LayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(false)

  useAlgoUsd()

  // Countdown logic start
  const { isReady, showTimer, diff, timer, countdown } = useLaunchTimer()

  const [showConfetti, setShowConfetti] = useState(false)
  const prevShowTimer = usePrevious(showTimer)

  useEffect(() => {
    if (!showTimer && prevShowTimer) {
      setShowConfetti(true)
    }
  }, [prevShowTimer, showTimer])

  if (!isReady) {
    return null
  }

  if (showTimer) {
    return <LaunchTimer timer={timer} countdown={countdown} total={diff} />
  }
  // Countdown logic end

  return (
    <>
      <div className="h-full flex">
        <MobileNav pathname={pathname} sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
        <DesktopNav pathname={pathname} />

        <div className="lg:pl-64 flex flex-col w-0 flex-1 min-h-screen">
          <div className="sticky top-0 z-50 flex-shrink-0 flex h-16 bg-white border-b border-gray-200">
            <MenuButton setSidebarOpen={setSidebarOpen} />
            <Header />
          </div>

          {children}
        </div>
      </div>

      {/* 🎉 */}
      <Confetti key={`${showConfetti}`} show={showConfetti} />

      <TosBanner />
    </>
  )
}
